import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false);  // 禁止凍結
export const alertSlice = createSlice({
  name: 'alert',
  initialState: {
    Snackbar: {
      open: false,  // 訊息提示
      type: null,  // 類型：error warning info success
      msg: null
    },
    Dialog: {
      open: false,  // 對話視窗
      option: null
    }
  },
  reducers: {
    alertUpdate: (state, action) => {
      return action.payload;
    },
  },
});
export const alertSelect = (state) => state.alert;
export const { alertUpdate } = alertSlice.actions;
export default alertSlice.reducer;